import {
	ActivatedRouteSnapshot,
	CanActivateFn,
	CanMatchFn,
	Router,
	RouterStateSnapshot,
} from '@angular/router';
import { LocalStorageService } from '../../services/localstorageService.service';
import { inject } from '@angular/core';
import { UserService } from '../../services/user.service';
import { of } from 'rxjs';
import { LOGIN_REGISTER } from '../../app.routes.constants';

export const ChangePasswordGuard: CanActivateFn | CanMatchFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
) => {
    const localStorageService = inject(LocalStorageService);
    const router = inject(Router);
    const userService = inject(UserService);

    const token = localStorageService.getToken();

    if (token) {
        const user = userService.userLogged();
        if (user?.flagForgotpwd) {
            router.navigate([LOGIN_REGISTER.LOGIN_REGISTER_CHANGE]);
            return of(false);
        }
    }
    return of(true);
};
